/** Código corto (p. ej. 0993/804) cuando DiseñoMuestra viene vacío en presupuestos nuevos. */
export function extractDesignCodeFromCliente(designCliente = "") {
  const dc = String(designCliente ?? "").trim();
  if (!dc) return "";
  const m = dc.match(/^(\d{4}[/-]\d+)/);
  return m ? m[1] : "";
}

export function getCpDesignDisplay(row) {
  const designCliente = row?.designCliente?.trim?.() || "";
  const disenoMuestra =
    row?.DiseñoMuestra?.trim?.() ||
    extractDesignCodeFromCliente(designCliente);
  const referenciaPedido = row?.ReferenciaPedido?.trim?.() || "";
  const idPedv =
    row?.IdPedv != null && Number.isFinite(Number(row.IdPedv))
      ? Number(row.IdPedv)
      : null;
  return { designCliente, disenoMuestra, referenciaPedido, idPedv };
}
